var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 77,
    viewBox: "0 0 58 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.79 0C44.67 0 57.58 12.92 57.58 28.79C57.48 44.4 40.04 63.54 28.79 76.36C17.54 63.54 0.09 44.4 0 28.79C0 12.91 12.92 0 28.79 0Z",
    fill: "#5EB5AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7899 47.2801C38.5099 47.2801 46.4499 39.35 46.4499 29.62C45.5499 6.23005 12.0399 6.24005 11.1399 29.62C11.1399 39.34 19.0699 47.2801 28.7999 47.2801H28.7899Z",
    fill: "#033239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.85b958b80f674b5ad1919585a0a6cb46.svg";
export { ForwardRef as ReactComponent };